export default "__VITE_ASSET__N$qq6sL4__"